var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatDots = function SvgIconChatDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 6.25v14.097l2.61-2.182a1.73 1.73 0 0 1 1.124-.415H20V6.25zM2.513 4.763A1.75 1.75 0 0 1 3.75 4.25h16.5A1.75 1.75 0 0 1 22 6v12a1.75 1.75 0 0 1-1.75 1.75H7.832L4.87 22.227l-.004.003A1.75 1.75 0 0 1 2 20.895V6c0-.464.184-.91.513-1.237M9.375 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.75-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatDots;